import React, { useState, useEffect } from 'react'
import Input from './../../../input/Input';
import MediaLoad from './../../../media-load/MediaLoad';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Button from './../../../button/Button';
import Select from './../../../select/Select';

let validateNumber = 0;
const FilesDownload = ( props ) => {
    let [ load, setLoad ] = useState(false);
    let [ error, setErrors ] = useState(false);
    let [ forceValidate, setForceValidate ] = useState(false);

    useEffect(() => {
        if(!load && !props.edit) {
            props.onChange({
                for: '',
                files: [
                    {
                        text: '',
                        icon: '',
                        file: '',
                        download_url: '',
                        file_type: '',
                        file_weight: '',
                    },
                ],
                header: '',
            }, props.index);
            setLoad(true);
        }
        if(!load) {
            validateNumber = props.validate;
        }
    }, [load])

    useEffect(() => {
        if(!load && props.edit) {
            if(!props.data.files) {
                props.onChange({
                    for: '',
                    files: [
                        {
                            text: '',
                            icon: '',
                            file: '',
                            download_url: '',
                            file_type: '',
                            file_weight: '',
                        },
                    ],
                    header: '',
                }, props.index)
            }
            setLoad(true);
        }
    }, [load])

    useEffect(() => {
        if(props.validate !== validateNumber) {
            validate();
        }
    }, [props.validate])

    const validate = async() => {
        await setForceValidate(true);
        await wait(100);
        await setForceValidate(false);
        let errors = await checkErrors();
        if(errors) {
            setErrors(true);
        }else{
            setErrors(false);
        }
    }

    const handleRLDDChange = (result) => {
        if (!result.destination) return;
        const items = Array.from(props.data.files);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        saveData(items);
    }

    const updateFields = (val, index, label) => {
        let newData = props.data.files;
        newData.map((item, i) => i == index ? item[label] = val : item);
        saveData(newData);
    }

    const addItem = () => {
        let newData = [...props.data.files, {
            text: '',
            icon: '',
            file: ''
        }]
        saveData(newData);
    }

    const removeItem = (index) => {
        let newData = props.data.files.filter((item, i) => i == index ? false : item);
        saveData(newData);
    }

    const saveData = (data) => {
        props.onChange({
            ...props.data,
            files: data
        }, props.index)
    }

    async function wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
    }

    let checkErrors = () => {
        let result;
        let elements = document.querySelectorAll(`.files-download-box-${props.index} .error`);
        if( elements.length > 0 ) {
            result = true;
        } else {
            result = false;
        }
        return result;
    }

    const updateValue = (val, label) => {
        let newData = props.data;
        newData[label] = val;
        props.onChange({
            newData
        })
    }

    const handleKeyDown = (e, functionName, functionValue = false) => {
        if (e.key === 'Enter') {
            functionName(functionValue)
        }
    }

    const rolledSection = (index) => {
        if(typeof window !== "undefined") {
            let sections = document.querySelectorAll(`.files-download-box-${props.index} .files-download-content`);
            sections[index].children[1].classList.toggle('active');
        }
    }

    const optionsFor = [
        {
            value: "all",
            text: "Każdego"
        },
        {
            value: "Architekt",
            text: "Architekt"
        }
    ];

    return (
        <div className={error ? `section-wrapper files-download-box error-section files-download-box-${props.index}` : `section-wrapper files-download-box files-download-box-${props.index}`}>
            <div className="row-section">
                <Select name="type"
                        label="Sekcja dostępna dla"
                        data={ optionsFor } 
                        value={ props.data.for }
                        forceValidate={ forceValidate }
                        handle={ (val) => { updateValue(val, "for") } } />
            </div>
            <div className="row-section">
                <Input  required={ true }
                    setFunction={ val => updateValue(val, 'header') }
                    value={props.data.header}
                    label={ 'Nagłówek' }
                    regExp={ /.*/ }
                    minChar={ 3 } 
                    forceValidate={ forceValidate } 
                />
            </div>
            <DragDropContext onDragEnd={handleRLDDChange}>
                <Droppable droppableId="section-items">
                    {(provided) => (
                        <div className="section-items" {...provided.droppableProps} ref={provided.innerRef}>
                        {props.data && props.data.files && props.data.files.map((item, index) => (
                            <Draggable key={String(index)} draggableId={String(index)} index={index}>
                                {(provided) => provided && (
                                    <div className="files-download-content" {...provided.draggableProps} ref={provided.innerRef}>
                                        <div className="section-index">
                                            <span onClick={() => rolledSection(index)}
                                                aria-label="Zwiń lub rozwiń sekcje"
                                                tabIndex="0"
                                                role="button"
                                                onKeyDown={(e) => handleKeyDown(e, rolledSection, index)}>Plik {index + 1} {item?.text ? "-" : ""} {item?.text}</span>
                                            {!error &&
                                            <i {...provided.dragHandleProps} 
                                                className="material-icons"
                                                aria-label="Przeciągnij sekcje"
                                                tabIndex="0"
                                                role="button">open_with</i>
                                            }
                                            <i onClick={() => removeItem(index)} 
                                                aria-label="Usuń sekcje"
                                                tabIndex="0"
                                                role="button"
                                                onKeyDown={(e) => handleKeyDown(e, removeItem, index)}
                                                className="material-icons remove-item-icon">delete</i>
                                        </div>
                                        <div className="content">
                                            <div className="row-section">
                                                <Input  required={ true }
                                                    setFunction={ val => updateFields(val, index, 'text') }
                                                    value={item.text}
                                                    label={ 'Opis pliku do pobrania' }
                                                    regExp={ /.*/ }
                                                    minChar={ 3 } 
                                                    forceValidate={ forceValidate } 
                                                />
                                            </div>
                                            <div className="row-section">
                                                <MediaLoad forceValidate={ forceValidate } setFunction={ val => updateFields(val, index, 'icon') } value={item.icon} label={"Ikona"} />
                                            </div>
                                            <div className="row-section">
                                                <MediaLoad setFunction={ val => updateFields(val, index, 'file') } value={item.file} label={"Plik do pobrania"} />
                                            </div>
                                            <div className="row-section">
                                                <Input  required={ false }
                                                    setFunction={ val => updateFields(val, index, 'download_url') }
                                                    value={item.download_url}
                                                    label={ 'Link zamiast wgranego pliku' }
                                                    regExp={ /.*/ }
                                                    minChar={ 0 } 
                                                />
                                            </div>
                                            <div className="row-section">
                                                <Input  required={ false }
                                                    setFunction={ val => updateFields(val, index, 'file_type') }
                                                    value={item.file_type}
                                                    label={ 'Typ pliku' }
                                                    regExp={ /.*/ }
                                                    minChar={ 1 } 
                                                />
                                            </div>
                                            <div className="row-section">
                                                <Input  required={ false }
                                                    setFunction={ val => updateFields(val, index, 'file_weight') }
                                                    value={item.file_weight}
                                                    label={ 'Waga pliku np. 10,2 MB' }
                                                    regExp={ /.*/ }
                                                    minChar={ 1 } 
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Draggable>
                        ))}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
            <div className="add-item-in-section">
                <Button title="Dodaj kolejny plik do pobrania" setFunction={() => addItem()} />   
            </div>
        </div>
    );
}

export default FilesDownload;